import React, { Component } from 'react';
import { API_URL } from '../../constants/api';
import { apiBatchRequest, apiPut } from '../../utils/api_service';
import { getDistinctByProperty, isInputValid, setSectionAttributeValueByKey, UpdateFieldsWithConfiguration } from '../../utils/helper';
import { ShowToast, toastType } from '../../utils/toast-service';
import FormGenerator from '../common/FormGenerator';
import commonLabels from '../../constants/messageConstants';
import { controlType } from '../../constants/common';
import { Button } from '@material-ui/core';
import PageHeader from '../common/PageHeader';
import _, { zip } from 'lodash';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

export class AddEditClient extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      clientContactDetails: [],
      clientDetails: [],
      allMarketStateData: [],
      updatedClientContactDetails: [],
      updatedClientDetails: []
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Transition.GetClientContactDetails +
          '?clientId=' +
          this.props.clientId,
        key: 'clientContactDetails'
      },
      {
        url: `${API_URL.Market.GetMarketCityStateMasterData}?stateId=${-1}`,
        key: 'allMarketStateData'
      },
      {
        url: API_URL.Transition.GetClientDetail +
          '?clientId=' +
          this.props.clientId,
        key: 'clientDetails'
      }

    ])
      .then(
        ({
          clientContactDetails,
          allMarketStateData,
          clientDetails
        }) => {
          this._asyncRequest = null;
          if (clientContactDetails.success === true) {
            this.setState({
              clientContactDetails: clientContactDetails.data || [],
              allMarketStateData: allMarketStateData.data || [],
              clientDetails: clientDetails.data || [],
              updatedClientDetails: clientDetails.data || [],
              // updatedClientContactDetails: clientContactDetails.data || []
            });

            console.log('from props', this.props.clientDetails);
            console.log(allMarketStateData);
          } else {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          'Server error'
        );
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  getClientContactChanges = (formFields) => {
    console.log(formFields);
    this.setState({ updatedClientContactDetails: formFields });
  };

  getClientChanges = (formFields) => {
    console.log(formFields);
    this.setState({ updatedClientDetails: formFields });
    // await this.validateClientDetails(formFields);
  };

  handleClientSubmit = () => {
    const { updatedClientDetails, updatedClientContactDetails } = this.state;
    console.log('updatedClientDetails', updatedClientDetails);
    console.log('updatedClientContactDetails', updatedClientContactDetails);
    this.validateClientDetails(updatedClientDetails);
  }

  validateRequiredFields = (formElementFields, stateToBeUpdate = {}) => {
    // console.log(formElementFields[0].attributeValue);
    let IsValid = true;
    formElementFields.forEach((ele) => {
      if (ele.isVisible === true && ele.isEditable === true) {
        isInputValid(ele.attributeValue, ele, formElementFields);
        if (ele.isInErrorState === true) {
          IsValid = false;
        }
      }
    });
    // console.log(formElementFields);
    stateToBeUpdate = {
      // ...stateToBeUpdate,
      updatedClientDetails: formElementFields
      // reloadPtf: !this.state.reloadPtf
    };
    this.setState(stateToBeUpdate);

    return IsValid;
  };

  validateClientDetails = (formFields) => {
    if (this.validateRequiredFields(formFields)) {
      if (formFields.length !== 0 || this.state.updatedClientContactDetails.length !== 0) {
        const id = formFields.find((x) => _.camelCase(x.dbColumn) === _.camelCase('clientId')).attributeValue;
        const name = formFields.find((x) => _.camelCase(x.dbColumn) === _.camelCase('Name')).attributeValue;
        const address = formFields.find((x) => _.camelCase(x.dbColumn) === _.camelCase('Address')).attributeValue;
        const city = formFields.find((x) => _.camelCase(x.dbColumn) === _.camelCase('City')).attributeValue;
        const state = formFields.find((x) => _.camelCase(x.dbColumn) === _.camelCase('State')).attributeValue;
        const zipcode = formFields.find((x) => _.camelCase(x.dbColumn) === _.camelCase('ZipCode')).attributeValue;
        let val = true;
        if (zipcode === '' || zipcode === null) {
          val = false;
        } else if (name === '' || name === null) {
          val = false;
        } else if (address === '' || address === null) {
          val = false;
        } else if (city === '' || city === null) {
          val = false;
        } else if (state === '' || state === null) {
          val = false;
        }

        const validationFlag = this.validateRequiredFields(formFields);
        if (validationFlag && val) {
          apiBatchRequest([
            {
              url: `${API_URL.Transition.CheckDuplicate}?name=${name}&address=${address}&city=${city}&state=${state}&zipcode=${zipcode}&type=${'client'}&checkOnlyAddress=${true}&id=${id}`,
              key: 'duplicateRecords'
            }
          ])
            .then(({ duplicateRecords }) => {
              if (duplicateRecords.data && duplicateRecords.data.length > 0) {
                //const msg = 'Duplicate clients exists with same name/address: ' + duplicateRecords.data.join(',');
                const msg = 'Duplicate client(s) exists with same name : ' + duplicateRecords.data.join(',');

                ShowToast(
                  msg,
                  toastType.ERROR,
                  5000,
                  500,
                  'Duplicate Found'
                );
              } else {
                //  this.setState({ updatedClientDetails: formFields });
                apiPut(API_URL.Transition.UpdateClient, [...formFields, ...this.state.updatedClientContactDetails], {}).then(({ data: response }) => {
                  if (response.success === true) {
                    console.log(response);
                    ShowToast(
                      'Client details updated Successfully',
                      toastType.SUCCESS,
                      5000,
                      500
                    );
                  } else {
                    ShowToast(
                      response.msg,
                      toastType.error,
                      5000,
                      500
                    );
                  }
                }).catch(() => {
                  ShowToast(
                    commonLabels.somethingWrong,
                    toastType.ERROR,
                    false,
                    500
                  );
                });
                this.props.onViewChange();
              }
            }).catch(() => {
            });
        }
      } else {
        ShowToast(
          'No changes observed. Please make some changes to submit client details.',
          toastType.ERROR,
          5000,
          500,
          'No changes found'
        );
      }
    }
  }

  render() {
    const { clientContactDetails, clientDetails, allMarketStateData } = this.state;
    const clientDropdownSource = [
      {
        key: 'clientName',
        option: 'clientName',
        idField: 'ClientId',
        source: this.props.clientMasterData,
        onChange: this.newClientOptionChange
      },
      {
        key: 'state',
        option: 'stateName',
        idField: 'stateId',
        source: getDistinctByProperty(
          allMarketStateData || [],
          'stateCode'
        )
      },
      {
        key: 'role',
        option: 'roleName',
        idField: 'contactRoleId',
        source: null
      }
    ];

    const newclientContactDetailConfig = [
      //  { key: 'name', type: controlType.Autofill, multiple: false },
      { key: 'state', type: controlType.DropDown, multiple: false },
      { key: 'role', type: controlType.DropDown, multiple: false }
    ];

    const newclientDetailConfig = [
      //  { key: 'name', type: controlType.Autofill, multiple: false },
      { key: 'state', type: controlType.DropDown, multiple: false },
      { key: 'role', type: controlType.DropDown, multiple: false }
    ];

    const transitionSeparatorConfig = [
      {
        separatorBeforeKey: 'ClientName',
        label: 'Client Contact Details',
        // (this.state.selectedTransitionTypeId || '1').toString() === '2'
        //   ? 'Current Assignment Details'
        //   : 'Assignment Details',
        order: 1,
        row: 1,
        sectionColumn: 4,
        infoLabel: ''
        // (this.props.actionType !== 'Edit' && ((this.state.selectedTransitionTypeId || '1').toString() === '2' || (this.state.selectedTransitionTypeId || '1').toString() === '3'))
        //   //? 'Please select existing Client and Market having ongoing Property Transition for ' + ((this.state.selectedTransitionTypeId || '1').toString() === '2' ? 'Change In Ownership' : 'Termination')
        //   ? 'Please select an existing Client, Market and Legal Entity for the Property You want to ' + ((this.state.selectedTransitionTypeId || '1').toString() === '2' ? 'Change Ownership' : 'Terminate')
        //   : ''
      }
      // {
      //   separatorBeforeKey: 'NewClient',
      //   label: 'New Ownership Details',
      //   order: 2,
      //   row: 1,
      //   sectionColumn: 4
      // }
      // {
      //   separatorBeforeKey: 'ManagementPropertyName',
      //   label: 'Management Fee',
      //   order: 1,
      //   row: 2,
      //   sectionColumn: 10
      // }
      // {
      //   separatorBeforeKey: 'NewFeePercentage',
      //   label: 'New Ownership Management Fee',
      //   order: 2,
      //   row: 2,
      //   sectionColumn: 10
      // }
    ];
    return (
      <>
        <PageHeader
          key={'Edit_Client_Details'}
          title={'Client Details'}
          actionsConfig={[
            {
              icon: this.props.isInViewMode && <ArrowBackIcon size="small" className="back-button" />,
              onClick: this.props.onViewChange,
              title: 'Back to Clients'
            }
          ]}
        >
          Client Details
        </PageHeader>
        <div className={'row'}>
          <div className={'col-sm-4 col-sm-offset-8 field-control text-align-r'}>
            {!this.props.isInViewMode && <><Button
              variant="contained"
              color="primary"
              className="ptf-buttons"
              size="small"
              onClick={() => {
                this.props.onViewChange();
              }}
            >
              Cancel
            </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className="ptf-buttons"
                onClick={() => {
                  this.handleClientSubmit();
                }}
              >
                Submit
              </Button>
            </>}  </div>
        </div>
        <FormGenerator
          key="clientDetails"
          gridColumn={4}
          dropDownSource={clientDropdownSource}
          formFields={UpdateFieldsWithConfiguration(
            clientDetails || [],
            newclientDetailConfig
          )}
          // separatorConfig={transitionSeparatorConfig}
          ReloadForm={this.state.reloadClientContactDetails}
          saveChanges={this.getClientChanges}
          partialForm={true}
          Editable={!this.props.isInViewMode}
        ></FormGenerator>
        <PageHeader
          key={'Edit_Client_Contact_Details'}
          title={'Client Contact Details'}
        // actionsConfig={[
        //   {
        //       icon: <ArrowBackIcon size="small" className="back-button" />,
        //     onClick: this.props.onViewChange,
        //     title: 'Back to Transition List'
        //   }
        // ]}
        >
          Client Contact Details
        </PageHeader>
        <FormGenerator
          key="clientContactDetails"
          gridColumn={4}
          dropDownSource={clientDropdownSource}
          formFields={UpdateFieldsWithConfiguration(
            clientContactDetails,
            newclientContactDetailConfig
          )}
          separatorConfig={transitionSeparatorConfig}
          ReloadForm={this.state.reloadClientContactDetails}
          saveChanges={this.getClientContactChanges}
          partialForm={true}
          Editable={!this.props.isInViewMode}
        ></FormGenerator>
      </>
    );
  }
}

export default AddEditClient;
